module.exports = __webpack_public_path__ + "static/OklahomaStandard-PreservedBy-White-b601047e3d85cddb3f2fab1e67ed8b35.svg";